import { all, takeLatest, takeLeading } from 'redux-saga/effects';

import * as constants from './constants';
import { startAddActionSaga } from './saga.addAction';
import { startCreateActionFromSuggestionSaga } from './saga.createActionFromSuggestion';
import { startCreateMockActionSaga } from './saga.createMockAction';
import { startCreateMockSuggestionSaga } from './saga.createMockSuggestion';
import { startDeleteActionSaga } from './saga.deleteAction';
import { startDeleteSuggestionSaga } from './saga.deleteSuggestion';
import { startRejectSuggestionSaga } from './saga.rejectSuggestion';
import { startSaveSuggestionSaga } from './saga.saveSuggestion';
import { startUpdateActionSaga } from './saga.updateAction';

export function* watcher() {
  yield all([
    // Suggestion sagas
    takeLeading(
      constants.START_CREATE_ACTION_FROM_SUGGESTION,
      startCreateActionFromSuggestionSaga,
    ),
    takeLatest(constants.START_SAVE_SUGGESTION, startSaveSuggestionSaga),
    takeLeading(
      constants.START_CREATE_MOCK_SUGGESTION,
      startCreateMockSuggestionSaga,
    ),
    takeLeading(constants.START_REJECT_SUGGESTION, startRejectSuggestionSaga),
    takeLeading(constants.START_DELETE_SUGGESTION, startDeleteSuggestionSaga),

    // Action sagas
    takeLeading(constants.START_UPDATE_ACTION, startUpdateActionSaga),
    takeLeading(constants.START_DELETE_ACTION, startDeleteActionSaga),
    takeLeading(constants.START_CREATE_MOCK_ACTION, startCreateMockActionSaga),
    takeLeading(constants.START_ADD_ACTION, startAddActionSaga),
  ]);
}
